module.exports = __webpack_public_path__ + "static/media/ph.64c3d8b0.svg";